import {
  DataGrid,
  GridPaginationModel,
} from "@mui/x-data-grid";

import { Box } from "@mui/material";

import AppEmptyState from "../AppEmptyState";
import AppLoader from "../AppLoader";

import { AppDataTableProps } from "./types";

const AppDataTable = ({
  rows,
  columns,

  loading = false,

  rowCount = 0,

  page = 0,

  pageSize = 10,

  onPageChange,

  onPageSizeChange,

  ...props
}: AppDataTableProps) => {
  const tableHeight = Math.min(
    Math.max((Math.min(rows.length, pageSize) + 2) * 52 + 18, 340),
    650
  );

  return (
    <Box
      sx={{
        width: "100%",
        minWidth: 0,
        maxWidth: "100%",
        height: tableHeight,
        overflow: "hidden",
        borderRadius: 2,
        border: "1px solid",
        borderColor: "divider",
        bgcolor: "background.paper",
      }}
    >
      <DataGrid
        rows={rows}
        columns={columns}
        loading={loading}

        rowCount={rowCount}

        paginationMode="server"

        sortingMode="server"

        paginationModel={{
          page,
          pageSize,
        }}

        onPaginationModelChange={(
          model: GridPaginationModel
        ) => {
          if (model.pageSize !== pageSize) {
            onPageSizeChange?.(model.pageSize);
            return;
          }

          if (model.page !== page) {
            onPageChange?.(model.page);
          }
        }}

        pageSizeOptions={[
          10,
          25,
          50,
          100,
        ]}

        disableRowSelectionOnClick

        slots={{
          noRowsOverlay: AppEmptyState,

          loadingOverlay: AppLoader,
        }}

        sx={{
          border: 0,
          bgcolor: "background.paper",

          "& .MuiDataGrid-columnHeaders": {
            bgcolor: "action.hover",
            borderBottom: "1px solid",
            borderColor: "divider",
            minHeight: "48px !important",
          },

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 800,
            fontSize: "0.75rem",
            textTransform: "uppercase",
            color: "text.secondary",
          },

          "& .MuiDataGrid-cell": {
            alignItems: "center",
            borderColor: "divider",
          },

          "& .MuiDataGrid-row": {
            transition: "background-color 160ms ease",
            "&:hover": { bgcolor: "action.hover" },
          },

          "& .MuiDataGrid-footerContainer": {
            borderTop: "1px solid",
            borderColor: "divider",
          },

          "& .MuiDataGrid-virtualScroller": {
            overflowX: "auto !important",
            scrollbarWidth: "thin",
          },

          "& .MuiDataGrid-scrollbar--horizontal": {
            display: "block !important",
            minHeight: 12,
          },
        }}

        {...props}
      />
    </Box>
  );
};

export default AppDataTable;
